import axios from '../../utils/axios';

export const sendMail = async (data) => {
    return await axios.post('/api/mail', data);
}